import React from 'react'
import Fragment from '../common/fragment'


function FragmentCP(props) {
  return (
    <Fragment pos="ppp" {...props}>
      <p>
Las vallas son obstáculos. Las bayas son frutos. Una letra curva y otra hundida,
eso es la diferencia entre el placer de las dulces bayas del campo y los trazos de las
vallas del mundo. VallaBaya, Bayavalla: suenan igual, pero significan algo distinto.
Las murallas y los alimentos. El aire encerrado de las propiedades y la dulzura
expuesta de los arbustos.
      </p>
    </Fragment>
  )
}


export default FragmentCP
